import { render, staticRenderFns } from "./PickupSummary.vue?vue&type=template&id=540f1792&scoped=true&"
import script from "./PickupSummary.vue?vue&type=script&lang=js&"
export * from "./PickupSummary.vue?vue&type=script&lang=js&"
import style0 from "./PickupSummary.vue?vue&type=style&index=0&id=540f1792&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "540f1792",
  null
  
)

export default component.exports